module.exports = __webpack_public_path__ + "img/logo.48974765.png";